(function ($, njm) {
    'use strict';

    njm.views.listlandingSearch = Backbone.View.extend({

        events: {
            'keydown #pageInput': 'fnPagination',
        },
        fnPagination: function (event) {
            if (event !== undefined) {
                if (event.keyCode === 13) {
                    var pageInput = $('#pageInput').val();
                    var totalPageCount = $("#TotalPageCount").val();
                    if (pageInput !== undefined && totalPageCount !== undefined) {
                        if (pageInput.length == 0 || parseInt(pageInput) < 1) {
                            pageInput = 1
                        }
                        else if (parseInt(totalPageCount) < parseInt(pageInput)) {
                            pageInput = totalPageCount
                        }
                        $('input[name=page]').val(pageInput).trigger('change');
                    }
                }
            }
        }

    })
    //OnSuccess
    window.onSearchComplete = function (xhr) {
       
    }
})(jQuery, njm);

